import React, { useState ,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import "./Map.css";
import cukMap from "./assets/cukMap.png";
import catIndex from "./assets/cat.png";
import colorBox1 from "./assets/colorBox1.png";
import colorBox2 from "./assets/colorBox2.png";
import colorBox3 from "./assets/colorBox3.png";
import colorBox4 from "./assets/colorBox4.png";
import colorBox5 from "./assets/colorBox5.png";
import colorBox6 from "./assets/colorBox6.png";
import colorBox7 from "./assets/colorBox7.png";

const locations = [
  { id: 1, name: "김수환관(K)", top: 57, left: 14 },
  { id: 2, name: "니콜스관(N), 마리아관(M)", top: 49, left: 31 },
  { id: 3, name: "스머프동산", top: 49, left: 42 },
  { id: 4, name: "운동장(축제)", top: 42, left: 57 },
  { id: 5, name: "다솔관(D)", top: 28, left: 29 },
  { id: 6, name: "소피이바라관(학생회관, B)", top: 34, left: 40 },
  { id: 7, name: "광장", top: 43, left: 15 },
];

const boxSrc = [
  colorBox1,
  colorBox2,
  colorBox3,
  colorBox4,
  colorBox5,
  colorBox6,
  colorBox7,
];

const MIN_SPEED = 1.5;
const MAX_SPEED = 2.5;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}


const Map = () => {
  const [position, setPosition] = useState({ top: 0, left: 0, show: false });
  const [selectNow, setSelectNow] = useState(null);
  const navigate = useNavigate("");

  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();

    // Cleanup function if needed
    // return () => { cleanup };
  }, []);

  const mainBtnHandler = () => {
    navigate("/");
  };

  const handleCat = (top, left, id) => {
    setPosition({ top, left, show: true });
    setSelectNow(id);
  };

  return (
    <div className="map_page">
            <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>
      <div className="header"></div>
      <div className="content">
        <p className="text_name2">텍스트를 터치하면 지도에 고양이가 나와요!</p>
        <div className="map_box">
          <div className="map_cuk">
            <img src={cukMap} alt="학교 지도" className="map_img" />
            {position.show && (
              <img
                src={catIndex}
                className="map_cat"
                alt="고양이 위치"
                style={{
                  position: "absolute",
                  top: `${position.top}%`,
                  left: `${position.left}%`,
                }}
              />
            )}
          </div>
        </div>
        <div className="text_box">
          {locations.map((location) => (
            <div key={location.id} className="text_list">
              <div className="text_color">
                <img src={boxSrc[location.id - 1]} alt="건물색" />
              </div>
              <div
                className="text_name"
                onClick={() =>
                  handleCat(location.top, location.left, location.id)
                }
                style={{
                  color: selectNow === location.id ? "#3A27B2" : "black",
                }}
              >
                {location.name}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <button
          className="mainBtn"
          onClick={mainBtnHandler}
          alt="처음으로 버튼"
        >
          BACK
        </button>
      </div>
    </div>
  );
};

export default Map;
